import { render } from "./PolitiqueConfidentialitePage.vue?vue&type=template&id=0546cba2&scoped=true&ts=true"
import script from "./PolitiqueConfidentialitePage.vue?vue&type=script&lang=ts"
export * from "./PolitiqueConfidentialitePage.vue?vue&type=script&lang=ts"

import "./PolitiqueConfidentialitePage.vue?vue&type=style&index=0&id=0546cba2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0546cba2"]])

export default __exports__